


import { Component, Vue, Prop } from 'vue-property-decorator';
import Gallery from '@/utils/mixins/gallery';
import LayeringEngine from '@/components/LayeringEngine/index.vue';
import { FloorGallerySlide } from './FloorGallery.models';

@Component({
  mixins: [Gallery],
  components: {
    LayeringEngine
  }
})
export default class FloorGallery extends Vue {
  @Prop() private gallerySlides!: FloorGallerySlide[];

  // It comes from Gallery-Mixin so we have to set correct value of slides' number
  public slideNumber = 0;

  private created() {
    this.slideNumber = this.gallerySlides.length;
  }
}
